/**
 * 🔒 A bill of materials' own status (piece 18; decision 1091, superseding
 * 1053): Draft when made, Final once a Quote's save stores a line generated
 * from it, and set either way by a person on the list's Details. 🔨 Final
 * locks nothing; a list is locked only by every attached Deal being Lost
 * (decision 1090).
 */
import type { StatusDefinitionRow } from '../statusDefinitions';

export const BOM_STATUSES = ['Draft', 'Final'] as const;
export type BomStatus = (typeof BOM_STATUSES)[number];

/** Whether a value a request carries is a member, so a write names only one. */
export function isBomStatus(value: unknown): value is BomStatus {
  return typeof value === 'string' && (BOM_STATUSES as readonly string[]).includes(value);
}

/** The rows the migration seeds (decision 0639's rule); the database suite holds the table to these. */
export const BOM_STATUS_DEFINITIONS: readonly (StatusDefinitionRow & { statusValue: BomStatus })[] = [
  { entityType: 'BOMStatus', statusValue: 'Draft', label: 'Draft', colorGroup: 'inactive', sortOrder: 1 },
  { entityType: 'BOMStatus', statusValue: 'Final', label: 'Final', colorGroup: 'good', sortOrder: 2 },
];
